import React, { useEffect } from "react"
import { Headline } from "@shared"
import { PageSection } from "../../sections"

import Styles from "./hubspot.module.scss"

const HubSpotForm = props => {
  const {
    portalId,
    formId,
    id,
    captchaMsg = false,
    textColor = "black",
    title = "",
    description = ""
  } = props
  const [ready, setReady] = React.useState(false)

  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.hsforms.net/forms/v2.js"
    document.body.appendChild(script)

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: `#hubspotForm-${id}`
        })
      }
    })
  }, [])

  return (
    <PageSection
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      {title && (
        <Headline className={Styles.headline} size={5} color={textColor}>
          {title}
        </Headline>
      )}
      <div id={`hubspotForm-${id}`} />
      {description && (
        <p className={Styles.description} style={{ color: textColor }}>
          {description}
        </p>
      )}
      {captchaMsg && (
        <div className={Styles.formRow}>
          {/* if we hide their badge, this is required */}
          <p className={Styles.captcha}>
            This site is protected by reCAPTCHA and the Google{" "}
            <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms">
              Terms of Service
            </a>{" "}
            apply.
          </p>
          <div className="grecaptcha-badge" id="recaptcha" data-badge="inline" />
        </div>
      )}
    </PageSection>
  )
}

export default HubSpotForm
